export default {
	GTAG_ID: 'G-RZ0WT6MCFH',
	FACEBOOK_PIXEL_ID: '433447008701183',

	FACEBOOK_PAGE_URL: 'https://www.facebook.com/AtlasUSALLC',
	FACEBOOK_MESSENGER_URL: 'https://www.facebook.com/messages/t/1340491659435032',
	TELEPHONE_URL: 'tel:+17328168899',
	TELEPHONE: '732-816-8899',
	WHATSAPP_URL: 'https://wa.me/17328168899'
}
